import _ from "lodash"
import { forwardRef, useImperativeHandle, useRef, useState } from "react"
import { AsyncTypeahead } from "react-bootstrap-typeahead"
import { useTranslation } from "react-i18next"
import { map } from "@src/config"
import { useLocalization } from "@src/localization"

type FENCEPOST = {
  lat: number
  lng: number
}

type SearchCityFenceProps = {
  onSearchResult: (coordinates: FENCEPOST[]) => void
}

export const SearchCityFence = forwardRef(({ onSearchResult }: SearchCityFenceProps, ref) => {
  const { t } = useTranslation()
  const { language } = useLocalization()
  const [options, setOptions] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const typeaheadRef = useRef<any>(null)

  useImperativeHandle(ref, () => ({
    clearSearch: () => {
      if (typeaheadRef.current) {
        typeaheadRef.current.clear()
      }
    },
  }))

  const handleSearch = (query) => {
    setIsLoading(true)
    if (!query) {
      setIsLoading(false)
      return
    }

    const url = `${map.openStreetQueryUrl}${encodeURIComponent(query)}&accept-language=${language}`
    fetch(url)
      .then((resp) => resp.json())
      .then((data) => {
        let filterGeoJsonType = data.filter(function (data) {
          return data.geojson.type === "MultiPolygon" || data.geojson.type === "Polygon"
        })
        setOptions(filterGeoJsonType)
      })
      .finally(() => setIsLoading(false))
  }

  const renderCoordinate = (paths) => {
    var coordinates = []
    let position = 0
    paths.map((location) => {
      if (position % 30 === 0) {
        coordinates.push({ lat: location[1], lng: location[0] })
      }
      position++
      return true
    })
    onSearchResult(coordinates)
  }

  const handleChange = (selectedOptions) => {
    selectedOptions.forEach((option) => {
      if (option.geojson.type === "MultiPolygon") {
        renderCoordinate(option.geojson.coordinates[0][0])
      } else if (option.geojson.type === "Polygon") {
        renderCoordinate(option.geojson.coordinates[0])
      } else {
        alert("option.geojson.type: MultiPolygon & Polygon")
      }
    })
  }

  const renderDiv = (options) => {
    return <div>{options.display_name}</div>
  }

  return (
    <AsyncTypeahead
      className="mt-2 flex-row"
      ref={typeaheadRef}
      id="type_ahead"
      isLoading={isLoading}
      options={options}
      labelKey="display_name"
      delay={500}
      onSearch={handleSearch}
      onChange={handleChange}
      placeholder={t("settings.fence.search_city")}
      renderMenuItemChildren={(option, props, index) => {
        return isLoading ? <div>Loading...</div> : renderDiv(option)
      }}
    ></AsyncTypeahead>
  )
})
